import React, { useEffect, useState } from "react";
import { pendingApiCalls$ } from "../../../config/axios/axios-instance";
import "./styles.scss";

const LoadingSpinner = () => {
  const [pendingApiCalls, setPendingApiCalls] = useState(0);

  /**
   * @description This useEffect will listen to the pendingApiCalls$ observable and update the state
   * accordingly to show the loading spinner or not based on the pendingApiCalls value.
   */
  useEffect(() => {
    const loadingObservableListener = pendingApiCalls$.subscribe((pendingApiCalls) => {
      setPendingApiCalls(pendingApiCalls);
    });
    return () => {
      loadingObservableListener.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let loadingSpinner = <span></span>;

  if (pendingApiCalls > 0) {
    loadingSpinner = (
      <>
        <div className={"pre-loader-bg"} />
        <div className={`pre__loader-wrapper active`}>
          <div id="preloader">
            <div id="loader" />
          </div>
        </div>
      </>
    );
  }

  return loadingSpinner;
};

export default LoadingSpinner;
